// AUTO-GENERATED by scripts/gen-build-info.js — do not edit.
export const BUILD_INFO = { sha: 'f84842c', builtAt: '2026-11-03 16:22 UTC' };
